<span class="contract-expiration-container" *ngIf="array.contract_status">
    <span *ngIf="expirationStatus.svg" class="expiration-icon-container">
        <pureui-svg [class]="expirationStatus.class" [svg]="expirationStatus.svg" height="15"></pureui-svg>
    </span>
    <span class="expiration-description">
        {{ expirationStatus.text }}
    </span>
</span>
